export class ForgotPasswordRequestVO{
    private emailId: string;
    private newPassword: string;
    private confirmPassword: string;
    private resetToken: string;

    public setNewPassword(newPassword: string): void{
        this.newPassword = newPassword;
    }
    public getNewPassword(): string{
        return this.newPassword;
    }

    public setConfirmPassword(confirmPassword: string): void{
        this.confirmPassword = confirmPassword;
    }
    public getConfirmPassword(): string{
        return this.confirmPassword;
    }

    public setEmailId(emailId: string): void{
        this.emailId = emailId;
    }
    public getEmailId(): string{
        return this.emailId;
    }

    public setResetToken(resetToken: string): void{
        this.resetToken = resetToken;
    }

    public getResetToken(): string{
        return this.resetToken;
    }
}


// WEBPACK FOOTER //
// ./src/app/forgotpassword/forgotpassword.model.ts